/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { BankAccount } from '@app/shared/components/bank-accounts/bank-account.model';

@Component({
  selector: 'app-bank-data',
  templateUrl: './bank-accounts.component.html',
  styleUrls: ['./bank-accounts.component.scss'],
})
export class BankAccountsComponent implements OnInit {
  @Input() parentFormGroup: FormGroup;
  @Input() single = false;
  @Input() required = false;
  @Input() extended = false;

  public static getBankData(required: boolean = false): FormGroup {
    if (required) {
      return new FormGroup({
        id: new FormControl(null),
        name: new FormControl(null, [Validators.required]),
        iban: new FormControl(null, [Validators.required]),
        bic: new FormControl(null, [Validators.required]),
        abbreviation: new FormControl(null),
        beneficiary_name: new FormControl(null),
        address: new FormControl(null),
        currency_id: new FormControl(null),
        currency: new FormControl(null),
        sort_code: new FormControl(null),
        account_number: new FormControl(null),
      });
    } else {
      return new FormGroup({
        id: new FormControl(null),
        name: new FormControl(null),
        iban: new FormControl(null),
        bic: new FormControl(null),
        abbreviation: new FormControl(null),
        beneficiary_name: new FormControl(null),
        address: new FormControl(null),
        currency_id: new FormControl(null),
        currency: new FormControl(null),
        sort_code: new FormControl(null),
        account_number: new FormControl(null),
      });
    }
  }

  public static createMany(bankAccounts: Array<BankAccount>, required: boolean = false) {
    const formArray: FormArray = new FormArray([]);
    bankAccounts.forEach((venue: any) => {
      formArray.push(BankAccountsComponent.getBankData(required));
    });
    return formArray;
  }

  constructor() {}

  ngOnInit() {
    setTimeout(() => {
      // @ts-ignore
      if ((this.parentFormGroup.get('bank_accounts').length <= 0 && this.required) || this.single) {
        this.addBankData();
      }
    });
  }

  addBankData() {
    // @ts-ignore
    this.parentFormGroup.get('bank_accounts').push(BankAccountsComponent.getBankData(this.required));
  }

  removeBankData(index: number) {
    this.parentFormGroup.get('bank_accounts')['controls'].splice(index, 1);
    this.parentFormGroup.get('bank_accounts').updateValueAndValidity();
  }
}
